export default __webpack_public_path__ + "static/media/PTW.63a5a1ad.jpg";